import React, { Component } from 'react';
import { Tasks } from "./tasks";
import { Comments } from "./comments";
import SDate from "./sdate.js";
import { AtchList } from "./atchList.js";
import { Ref } from './App';
//import DatePicker from 'react-date-picker';

import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import cs from 'date-fns/locale/cs';
setDefaultLocale('cs');

export class Dialog extends Component {
  resolve;
  detail = {}
  rowCopy = {}
  pozadovanoCopy = null;
  changedRows = {}

  state = { 
    display: "dnone", 
    row: {},
    fields: [],
    error: false,
    preview: "",
    files: {},
    saving: ""
  }

  emptyInputs() {
    this.changedRows = {}
    /*
    this.setState({ row: {
      pozadovanoDo: null,
      realizovanoDne: null,
      druhPrace: null,
      priorita: null
    }});
    */
  }

  close =()=> {
    this.setState({ display: "dnone" });
  }

  show = async (row, fields) => {
    registerLocale('cs', cs);

    this.emptyInputs();
    this.detail = {};

    if(row) {
      this.rowCopy = {...row};

      this.setState({ 
        display: "dblock", 
        saving: "",
        row: row,
        fields,
        preview: "",
        error: false,
        files: {}
      });

      if(row.id) {
        this.detail = await window.fetchj("/detail/" + row.id);

        if(((this.detail||{}).aktivita||{}).error) {
          console.error("Chyba ze serveru", this.detail);
          Ref.InfoDialog.current.show("Chyba: " + this.detail.aktivita.errorMsg);
        }

        if((this.detail||{}).aktivita) {
          const rowD = (this.detail.aktivita.data || [])[0] || {};
          this.rowCopy = {...rowD};

          this.setState({ 
            row: rowD,
            fields: this.detail.aktivita.fields || [],
          });
        }
      }
    }
    else {
      this.emptyInputs();
      this.setState({ 
        display: "dblock",
        saving: "",
      });
    }
 
    return new Promise(rs => this.resolve = rs)
  }

  save = async e => {
    let res;

    if(!this.state.row.predmetPozadavku) {
      this.setState({ error: true});
      return
    }

    this.setState({ saving: "saving" });
    Ref.loading = true;

    if(Object.values(this.state.files).length) {
      res = await this.send();
      this.close();
    }
    else {
      this.close();
      res = await this.send();
    }

    this.setState({ saving: "" });
    Ref.loading = false;

    if(res.error) {
      await Ref.InfoDialog.current.show(res.errorMsg);
      this.setState({ 
        display: "dblock",
        saving: ""
      });
    }
    else {
      this.resolve(this.state.row);
      this.setState({ 
        error: false,
        saving: ""
      });
    }
  }

  send = async () => {
    const row = this.state.row;
    const time = SDate.time;

    if(!row) return;

    const data = {}
    let prilohy = [];

    //vyfiltruje pouze zmenene pole
    Object.entries(this.changedRows).filter(f => f[1]).forEach(([key]) => {
      data[key] = row[key];

      //pokud se zada datum, zformatuje se jako YYYY-MM-DD a neodesle se cas
      if(row[key] instanceof Date) {
        data[key] = SDate(row[key]).ymd;
      }

      if(data.stav)
         data.pozadovanoDo = "NULL";
    })

    if(row.id) data.id = row.id;

    let json = { aktivita: [data] }

    //zalozeni noveho pozadavku a zjisteni jeho ID
    const aktivita = await window.fetchj("/pozadavek", json);
    const idAktivita = ((aktivita.data || [])[0] || {}).id;

    for(let file of Object.values(this.state.files)) {
      const fileData = this.fileChunks(await this.toBase64(file));

      let priloha = {
        attNameExt: file.name,
        idAktivita: idAktivita,
        ownRecId: file.name + "_" + time,
      };

      for(let i=0;i<fileData.length;i++) {
        (this.state.files[file.name]||{}).uploaded = (i/(fileData.length-1)*100);
        this.setState(s=>s);

        priloha.partNo = i+1;
        priloha.attBlob = fileData[i];
        priloha.lastPart = i === (fileData.length - 1)
        
        await window.fetchj("/json", {
          agenda: "activity_chat_list",
          data: [priloha]
        });
      }
    }

    return aktivita;
  }

  fileChunks(b64, size = 500*1024) { //500kB
    const chunks = [];
    let str = b64;
    
    do {
      chunks.push(str.substring(0, size));
      str = str.substring(size, str.length);
    } while (str.length > 0);
  
    return chunks;
  };

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(',').pop());
    reader.onerror = error => reject(error);
  });

  preview =href=> {
    Ref.PrevDialog.current.show(href);
    //this.setState({ preview: href});
  }

  cancel =async e=> {
    let res = true;
    
    if((e.target.id == "table-filter" || e.target.id == "zrusit" || e.target.className == "close") && !Ref.loading) {
      if(!this.saveDisabled()) {
        res = await Ref.InfoDialog.current.show("Opravdu chcete zahodit změny?", "Yes", "No");
      }

      if(res) {
        this.close();
        this.resolve(false);
      }
    }
  }

  inputChange =e=> {
    const tg = e.target;
    this.state.row[tg.id] = tg.value;

    if(tg.id == "stav") {
      const changed = this.changeTest(tg.value, this.rowCopy[tg.id], "select", tg.id);

      if(changed) {
        if(!this.pozadovanoCopy)
          this.pozadovanoCopy = this.state.row.pozadovanoDo;

        this.state.row.pozadovanoDo = null;
      }
      else {
        this.state.row.pozadovanoDo = this.pozadovanoCopy;
      }
    }

    this.setState({ data : this.state.row });
  }

  dateChange = (date, field) => {
    this.state.row[field] = date;
    this.setState({ data : this.state.row });
  }

  getFData =field=> {
    const fd = (this.state.fields.find(f => f.field == field) || {});
    const override = (this.state.row.fields_override || []).find(f => f.field == field) || {};
    return { ...fd, ...override};
  }

  select =field=> {
    const fData = this.getFData(field);

    const value = this.state.row[field] === undefined ? 
      this.state.row[field] = "" /*((fData.enum||[])[0] || {}).key*/ : 
      this.state.row[field];

    const changed = this.changeTest(value, this.rowCopy[field], "select", field);
    const changedCs = changed ? " changed" : "";

    return (
      <>
        <div>{fData.caption}</div>
        <select 
          id={field} value={value} 
          disabled={!fData.editable || (fData.enum || []).length <= 1} 
          className={"form-control" + changedCs}
          onInput={this.inputChange}
        >
          {(fData.enum || []).map(enm => <option disabled={!enm.canSet} value={enm.key}>{enm.disp}</option>)}
        </select> 
      </>
    )
  }

  printSize(size) {
		var sizes = "kMGT" //PEZY";

		for(let i=sizes.length-1;i>=0;i--) {
			if(size >= Math.pow(1024, i+1)) return (size/Math.pow(1024, i+1)).toFixed(2) + " " + sizes[i] + "B";
		}

		return size + " B";
	}

  input = (field, type = "text", notEmpty = false) => { 
    const fData = this.getFData(field);
    const error = notEmpty && this.state.error ? " error" : "";
    const txaDisabled = !fData.editable && this.state.row.id;    

    let value = this.state.row[field] === undefined ? 
      this.state.row[field] = ((type == "text" || type == "textarea") ? "" : 0) : 
      this.state.row[field];

      const changed = this.changeTest(value, this.rowCopy[field], type, field) ? " changed" : "";
      const inpEnabled = this.state.row.id ? fData.editable : fData.insertable

    if(type == "date") {
      value = !this.state.row[field] ? 
        this.state.row[field] = "" : SDate(this.state.row[field]);

      const changed = this.changeTest(value, this.rowCopy[field], type, field) ? " changed" : "";    

      return (
        <>
          <div>{fData.caption}</div>
          <DatePicker
            locale="cs" 
            dateFormat="PP" 
            disabled={!inpEnabled} 
            className={"form-control " + error + changed} 
            selected={value} 
            onChange={d=> this.dateChange(d, field)} 
            value={value} 
          />
        </>
      )
    }



    return (
      <>
        <div>{fData.caption}</div>
        {type == "textarea" ?
          <textarea id={field} value={value} disabled={txaDisabled} 
            className={"form-control" + error + changed} onInput={this.inputChange} /> :
          <input type={type} id={field} value={value} disabled={!inpEnabled} 
            className={"form-control " + error + changed} onInput={this.inputChange} />
        }
      </>
    )
  }

  notEmpty(value) {
    return value != "" || value !== null || value != undefined;
  }

  changeTest(value, orValue, type, field) {
    let changed = false;

    switch(type) {
      case "text": 
      case "textarea":
      case "select": 
        if(orValue === undefined && value === undefined) {
          changed = false;
        }
        else if(orValue === undefined && value === "") {
          changed = false;
        }
        else if(orValue != value) {
          changed = true;
        }
        break;
      case "date": 
        if(orValue === undefined && value === undefined) {
          changed = false;
        }
        else if(orValue === undefined && value === "") {
          changed = false;
        }
        else if(orValue === undefined && value === 0) {
          changed = false;
        }
        else if(SDate(value).dmy !== SDate(orValue).dmy) {
          changed = true;
        }
        break;
      
      case "number": changed = (orValue === undefined) ? (value != 0) : value != orValue; break;
    }

    this.changedRows[field] = changed;

    return changed;
  }

  removeFile(name) {
    delete this.state.files[name];
    this.changedRows._ext = !!Object.values(this.state.files).length;
    this.setState(s => s);
  }

  getFiles() {
    return Object.values(this.state.files).map(file => {
      const upl = file.uploaded || 0;

      return (
        <span className="fileInfo" style={{background: `linear-gradient(90deg, #9EFF5C ${upl}%, #FFF ${upl}%)`}} title={"Velikost: " + this.printSize(file.size)}>
          <span className="fName">{file.name}</span>
          <span className="icon fas fa-times" onClick={e=> this.removeFile(file.name)}></span>
        </span>
      )
    })
  }

  addAtch = async e => {
    for(let file of e.target.files) {
      if(file.size > 20*1024*1024) {
        Ref.InfoDialog.current.show("Max. velikost souboru musí být 20 MB.");
      }
      else {
        this.state.files[file.name] = file;
        this.changedRows._ext = true;
      }
    }

    e.target.value = null;

    this.setState({
      allowSend: true,
      files: this.state.files
    });
  }

  removeAtch = name => {
    this.setState({
      files: {}
    });
  }

  saveDisabled =()=> {
    return !Object.values(this.changedRows).some(s => s);
  }

  render() {
    const s = this.state;
    const inp = this.state.row;

    return (
      <div className={"modal " + s.display + " " + s.saving} id="table-filter">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" onClick={this.cancel}>×</button>
              <h4 className="modal-title">{inp.id ? "Detail požadavku - vytvořeno " + inp.createInfo : "Nový požadavek"}</h4>
            </div>
            <div className={"modal-body " + (!inp.id ? "novaAktivita" : "")}>
              <div id="oddil1" className={this.state.preview ? "height0" : "heightA"}>
                <div id="modalNazev">
                  {this.input("predmetPozadavku", "text", 1)}
                </div>
                <div id="modalCislo">
                  {this.input("cisloObjednavky")}
                </div>
                <div id="modalDruh">
                  {this.select("druhPrace")}
                </div>
                <div id="modalPriorita">
                  {this.select("priorita")}
                </div>

                <div id="modalTermin">
                  {this.input("termOdZakazn", "date")}
                </div>
                <div id="modalRealizace">
                  {this.input("realizovanoDne", "date")}
                </div>
                <div id="modalStav">
                  {this.select("stav")}
                </div>  
                <div id="modalPozadovano">
                  {this.input("pozadovanoDo", "date")}
                </div>
                
                <div id="modalAnalyza">
                  {this.input("hodAnalyzy", "number")}
                </div>
                <div id="modalKonzultace">
                  {this.input("hodKonzultace", "number")}
                </div>
                <div id="modalProgramatorske">
                  {this.input("hodProgramovani", "number")}
                </div>  
                <div id="modalPopis">
                  {this.input("detailniPopis", "textarea")}
                </div>
                <div id="modalPrilohy">
                  <div>Souhrn příloh</div>
                  <AtchList ref={Ref.AtchList} detail={this.detail} preview={this.preview}></AtchList>
                </div>
              </div>
              <div id="oddil1b">
                {!inp.id ? <>
                    <label id="labelFile">
                      <div id="fileInput" className="btn btn-warning"><i className="fa fa-upload"></i> Přílohy</div>
                      <input id="addAttachment" multiple={true} type="file" style={{display: "none"}} onInput={e=> this.addAtch(e)} />
                    </label>
                    <span id="files">{this.getFiles()}</span>
                </> : []
                }
                <button className="btn btn-primary" id="ulozit" disabled={this.saveDisabled()} onClick={this.save}>Uložit požadavek</button>
              </div>
              <div id="oddil2" className={this.state.preview ? "height0" : "heightA"}>
                <Tasks activity={inp.id} data={this.detail.ukol || {}} />
                <Comments activity={inp.id} chr={this.changedRows} 
                  canAddChat={inp.canAddChat} display={this.state.display} data={this.detail.chat || {}} 
                />  
              </div>
            </div>
            {/*
            <div className="modal-footer">
              <a className="btn btn-default" id="zrusit" onClick={this.cancel}>Zavřít</a>
              <div id="nacitani"></div>
            </div>
            */}
          </div>
        </div>
      </div>
    );
  }
}